import BrandLogoMobile from '@/assets/icons/brandLogoMobile.svg?react';
import CustomerAreaLogoMobile from '@/assets/icons/customerAreaLogoMobile.svg?react';
import { NotificationCenter } from '@/components/NotificationCenter/NotificationCenter';
import { SidebarMobile } from '@/components/SidebarMenu';
import { URLS } from '@/constants/urls';
import { useDemoContext } from '@/hooks/DemoContext';

import style from './styles.module.css';

export const HeaderConnected: React.FC = () => {
  const { isDemo } = useDemoContext();

  return (
    <div className={`${style.topHeaderConnected}${isDemo ? ` ${style.topHeaderConnectedWithDemo}` : ''}`}>
      <SidebarMobile />

      <div className={style.logos}>
        <a href={URLS.MTP_URL} className={style.brandLogo}>
          <BrandLogoMobile width={44} height={42} aria-label="logo meilleurtaux" />
        </a>
        <div className={style.customerLogo}>
          <CustomerAreaLogoMobile width={130} height={40} aria-label="logo espace client" />
        </div>
      </div>

      <NotificationCenter />
    </div>
  );
};
